<dropzone #dropzone
          [config]="config"
          [message]="placeholder"
          [disabled]="disabled"
          (success)="upload($event)"
          (removedFile)="remove($event)" (maxFilesExceeded)="maxFilesExceeded()">
</dropzone>
